import WebCam from "react-webcam"
import React, { useState} from "react"
import "../../css/Visualizarpdf.css"

import { Worker } from '@react-pdf-viewer/core';
// Import the main Viewer component
import { Viewer } from '@react-pdf-viewer/core';
// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
// default layout plugin
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
// Import styles of default layout plugin
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import axios from "axios";

import upload from "../../assets/Subir.svg"

//import pdf from "../../../src/PagosLicencia.pdf"

function Visualizarpdf(props) {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    // pdf file onChange state
    const [pdfFile, setPdfFile] = useState(null);

    // pdf file error state
    const [pdfError, setPdfError] = useState('');

    const [btnAvalible, setbtnAvalible] = useState(false)
    //datos del archivo
    const [dataFile,setdataFile] = useState(null);

    const [btndown, setbtndown] = useState(false);
    // handle file onChange event
    const allowedFiles = ['application/pdf'];

    const handleFile = (e) => {
        let selectedFile = e.target.files[0];
        setdataFile(selectedFile);
        if (selectedFile) {
            if (selectedFile && allowedFiles.includes(selectedFile.type)) {
                let reader = new FileReader();
                reader.readAsDataURL(selectedFile);
                reader.onloadend = (e) => {
                    setPdfError('');
                    setPdfFile(e.target.result);
                }
                setbtnAvalible(true);
                setbtndown(true);
            }
            
            else {
                setPdfError('No es valido: Solo puede escoger archivos PDF');
                setPdfFile('');
            }
        }
        else {
            //console.log('Seleccione un pdf');
        }
        //console.log(selectedFile)

    }

    const choosePdf = React.useCallback(() => {
        props.choosepdf(pdfFile);
    });
    //  <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.5.207/build/pdf.worker.min.js">

    return (

        <div className="container">
            {!props.pathpdf ? 
                <>
                    <form>

                        <div className="container">
                            <div className="row justify-content-evenly">


                                <div align="center" className="col-sm-4 vpdf-div-botton ">
                                    <label className="vpdf-button"> <span>CARGAR  <input accept=".pdf" hidden id="btnfile" className="vpdf-button" value="" type='file'
                                        onChange={handleFile} /></span></label>
                                </div>
                                <div align="center" className="col-sm-4">
                                    <button onClick={choosePdf} align="justify" type="button" disabled={!btnAvalible}
                                        className={btnAvalible ? "vpdf-button" : "vpdf-button-disable"}>
                                        GUARDAR </button>
                                </div>


                            </div>
                        </div>
                        <hr />




                        {pdfError && <span className='text-danger'>{pdfError}</span>}

                    </form>
                    {btndown ?
                        < div className="container vpdf-div-download">

                            <div className="row justify-content-evenly">
                                <div className="vpdf-div-btn" align="center">
                                    <a className="vpdf-download" href={pdfFile} download="Contrato"><img className="vpdf-btn-img" src={upload} /></a>
                                </div>
                            </div>
                        </div>
                        :
                        null}
                    <div className="viewer">
                        <hr />
                        {pdfFile && (
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                                <Viewer fileUrl={pdfFile}
                                    plugins={[defaultLayoutPluginInstance]}></Viewer>
                            </Worker>
                        )}

                        {!pdfFile && <>No se ha seleccionado ningún archivo</>}

                    </div>

                </> :
                
                    <div className="container">
                        <div className="row justify-content-evenly">
                            <div  className="col-sm-12 vpdf-div-botton ">
                            <h3 className="text-center"><strong>{props.titulo}</strong></h3>
                        </div>
                    </div>
                    <hr />

                        <div className="viewer">


                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                                <Viewer fileUrl={props.pathpdf}
                                    plugins={[defaultLayoutPluginInstance]}></Viewer>

                            </Worker>
                        </div>

                    </div>
      
                    

                }
        


        </div>
    );
}


export default Visualizarpdf;
